import { Component, Injector } from '@angular/core';
import {
  LoaderService,
  MessageService,
  ValidationResultService,
} from '@shared';
import { AlertsService, CategoryService } from '@shared-data';
import { GridRowUpchargePricingChangeset } from '../../models';
import { RestaurantItemService } from '../../services';
import { ActivatedRoute } from '@angular/router';
import { BasePricingChangesetComponent } from '../base-pricing-changeset/base-pricing-changeset.component';
@Component({
  selector: 'app-upcharge-changeset',
  templateUrl: './upcharge-changeset.component.html',
  styleUrl: './upcharge-changeset.component.scss',
})
export class UpchargeChangesetComponent extends BasePricingChangesetComponent {
  currentComponentId: number | null = null;

  constructor(
    validationErrorService: ValidationResultService,
    messageService: MessageService,
    loaderService: LoaderService,
    categoryService: CategoryService,
    restaurantItemsService: RestaurantItemService,
    activatedRoute: ActivatedRoute,
    injector: Injector,
  ) {
    super(
      validationErrorService,
      messageService,
      loaderService,
      restaurantItemsService,
      categoryService,
      activatedRoute,
      injector,
      GridRowUpchargePricingChangeset,
    );
  }
}
